import { CommonModule } from '@angular/common';
import { Component, Inject, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SessionStorageService } from '@app/core';
import {
  SessionStorageKeyTypes,
  SessionStorageValueTypes,
} from '@app/core/enums/session-storage-key-type.enum';
import { BaseWidget } from '@app/widgets/base-widget/base-widget';

@Component({
  selector: 'write-a-review-popup',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './write-a-review-popup.component.html',
})
export class WriteAReviewPopup extends BaseWidget {
  private readonly sessionStorageService = inject(SessionStorageService);

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<WriteAReviewPopup>,
  ) {
    super();
  }

  popupClose() {
    this.sessionStorageService.set(
      SessionStorageKeyTypes.reviewPopupClosedByUser,
      SessionStorageValueTypes.closed,
    );
    this.dialogRef.close();
  }

  performAction(action) {
    this.dialogRef.close(action);
  }
}
